import React, { useRef, useCallback, useState } from "react";
import { PlayButton } from "components";
import * as S from "./styles";

export const Slide17: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const handlePlayVideo = useCallback(() => {
    if (videoRef.current) {
      if (videoRef.current.played.length > 0 && !videoRef.current.paused) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  }, []);
  return (
    <S.Container>
      <S.Video>
        <PlayButton action={handlePlayVideo} playing={isPlaying} />
        <video loop ref={videoRef}>
          <source
            src="https://player.vimeo.com/external/605701721.hd.mp4?s=1cebf11a1d2dba619030bb9c687f3910411b2de9&profile_id=175"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
